export default {
  namespaced: true,
  state: {
    min_viewing_time: {
      selected: 15, //Value must exist in options
      options: [        
        { value: 1, text: "1 sec", selectedReachCriteriaText: '1 sec' },
        { value: 2, text: "2 sec", selectedReachCriteriaText: '2 sec' },
        { value: 5, text: "5 sec", selectedReachCriteriaText: '5 sec' },
        { value: 10, text: "10 sec", selectedReachCriteriaText: '10 sec' },
        { value: 15, text: "15 sec or 50% of length", selectedReachCriteriaText: '15 sec/50%' },
        { value: 20, text: "20 sec", selectedReachCriteriaText: '20 sec' },
        { value: 30, text: "30 sec", selectedReachCriteriaText: '30 sec' },
        { value: 60, text: "60 sec", selectedReachCriteriaText: '60 sec' },
        { value: 120, text: "120 sec", selectedReachCriteriaText: '120 sec' },
        { value: 180, text: "180 sec", selectedReachCriteriaText: '180 sec' }
      ]
    },
    measure_type: {
      selected: "absolute_reach", //Value must exist in options
      options: [
        { value: "absolute_reach", text: "Absolute" },
        { value: "relative_reach", text: "Relative" }
      ]
    }
  },
  getters: {
    getSelectedReachObj: state => state.min_viewing_time,
  },
  mutations: {
    updateMinViewingTimeSite(state, newSelection) {
      state.min_viewing_time.selected = newSelection;
    },
    updateMeasureTypeSite(state, newSelection) {
      state.measure_type.selected = newSelection;
    }
  }
};
